import React from "react";
import { useParams, Link } from "react-router-dom";
import blogPosts from "./blogPosts";

export default function BlogPostPage() {
    const { slug } = useParams();
    const post = blogPosts.find((p) => p.slug === slug);

    if (!post) {
        return (
            <div className="max-w-3xl mx-auto px-4 py-16 text-center">
                <h1 className="text-3xl font-bold text-gray-900 mb-4">Post not found</h1>
                <p className="text-gray-500 mb-6">The blog post you're looking for doesn't exist.</p>
                <Link to="/blog" className="text-accent-600 hover:underline">
                    &larr; Back to Blog
                </Link>
            </div>
        );
    }

    return (
        <div className="max-w-3xl mx-auto px-4 py-16">
            <Link to="/blog" className="text-sm text-accent-600 hover:underline mb-6 inline-block">
                &larr; Back to Blog
            </Link>
            <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-8">
                <span className="text-sm font-medium text-accent-600">{post.date}</span>
                <h1 className="text-3xl font-bold text-gray-900 mt-2 mb-8">{post.title}</h1>
                <div
                    className="blog-content"
                    dangerouslySetInnerHTML={{ __html: post.content }}
                />
            </div>
        </div>
    );
}
